Copy code
<template>
  <div class="emat-input-container" :class="{ 'without-label': !label }">
    <label
      v-if="label"
      :class="{ active: value || value === 0 }"
      class="emat-label"
    >
      {{ label }}
    </label>
    <input
      :disabled="disabled"
      class="emat-input"
      :class="{ active: value || value === 0 }"
      :type="type"
      :value="value"
      :min="min"
      :max="max"
      @input="$emit('input', $event.target.value)"
    />
  </div>
</template>

<script>
export default {
  name: 'EmatInput',
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    label: {
      type: String,
    },
    type: {
      type: String,
      default: 'text',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    min: {
      type: Number,
    },
    max: {
      type: Number,
    },
  },
};
</script>
